/** @flow */
import * as React from 'react';
import { withTheme } from 'styled-components';
import AgeRangeReaches from 'common/domain/AgeRangeReaches';
import AntennaReach from 'statsradio/domain/AntennaReach';
import GeolocalisationPrintingCard from './GeolocalisationPrintingCard';
import DemoGeoPrintingCard from './DemoGeoPrintingCard';
import type { ReachByGender, GeoMapTypes } from '../domain/DashboardData';
import GeolocationReach from '../domain/GeolocationReach';

type Props = {
  metrics: {
    reachByRegion: GeolocationReach[],
    reachByAgeRange: AgeRangeReaches,
    reachByGender: ReachByGender,
    antennaReach?: AntennaReach,
  };
  geoMapType: GeoMapTypes;
  geoMapData: Object;
  theme: any;
};

function DashboardPrintingDemoGeo({ metrics, geoMapType, geoMapData }: Props) {
  return (
    <div style={{ height: '430px' }} className="flexbox-children-spaced">
      <GeolocalisationPrintingCard geolocalisation={metrics.reachByRegion} antennaReach={metrics.antennaReach}
        geoMapType={geoMapType} geoMapData={geoMapData}
      />
      <DemoGeoPrintingCard style={{ maxWidth: '400px' }} gender={metrics.reachByGender}
        ageRange={metrics.reachByAgeRange}
      />
    </div>
  );
}

export default withTheme(DashboardPrintingDemoGeo);



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/printing/DashboardPrintingDemoGeo.js